import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splides = [];

document.querySelectorAll('.splide').forEach(slider => {
  const instance = new Splide(slider, {
    direction: 'ttb',
    height: '290px',
    type: 'loop',
    speed: 400,
    easing: 'cubic-bezier(0.85, 0, 0.15, 1)',
    drag: false,
    arrows: false,
    pagination: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplay: false, // ← 重要：オフにする
  });

  instance.mount();
  splides.push(instance);
});

// ★ ここが重要：タイマーは1つだけ
setInterval(() => {
  splides.forEach(splide => {
    splide.go('>');
  });
}, 1600);
